import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoggerService } from './logger.service';

const noop = (): any => undefined;
export const isDebugMode = !environment.production;

@Injectable()
export class ConsoleLoggerService implements LoggerService {
  // if (!environment.production) {
  //   const orig = console.log;
  //   console.log = function () {
  //     orig.apply(console, [
  //       `[${new Date().toISOString().replace('T', ' ').replace(/\..+/, '')}]`,
  //       ...arguments,
  //     ]);
  //   };
  get dog() {
    if (isDebugMode) {
      return console.info.bind(console, `🐶`);
    } else {
      return noop;
    }
  }
  get horse() {
    if (isDebugMode) {
      return console.info.bind(console, `🐴`);
    } else {
      return noop;
    }
  }
  get log() {
    if (isDebugMode) {
      return console.info.bind(console);
    } else {
      return noop;
    }
  }
  get info() {
    if (isDebugMode) {
      return console.info.bind(console);
    } else {
      return noop;
    }
  }
  get warn(): void {
    return console.warn.bind(console);
  }
  get error() {
    return console.error.bind(console);
  }
}
